import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Checkbox,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  Breadcrumbs,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Chip,
  CardContent,
  Grid,
  Card,
  InputAdornment,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import { Tooltip as RechartsTooltip } from "recharts";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  AttendanceEntryPost,
  // AttendanceEntryGet,
  wfhpostData,
  HomeworkTeachGet,
  HomeworkEvalGet,
  HomeworkEvalPOST,
  HomeworkEvalAnalyticsGet,
  // HomeworkgetData,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  CheckinAutocomplete,
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
  SprintEmpAutocomplete,
} from "../../../ui-components/global/Autocomplete";
import {
  GridToolbarContainer,
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridRowEditStopReasons,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import {
  AttendanceEntryGet,
  fetchExplorelitview,
  HomeworkGet,
} from "../../../store/reducers/Explorelitviewapireducer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendanceHistoryPDF from "../../reports/AttendanceHistoryPdf";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { nanoid } from "@reduxjs/toolkit";
import ScheduleIcon from "@mui/icons-material/Schedule";
import {
  fileUpload,
  imageUpload,
} from "../../../store/reducers/Imguploadreducer";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getConfig } from "../../../config";
import { Attachment } from "@mui/icons-material";
import * as Yup from "yup";

const EditHomework = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  console.log(params, "--params");

  const config = getConfig();
  const baseurl1 = config.BASE_URL;
  console.log(baseurl1, "url path");

  const location = useLocation();
  const state = location.state || {};
  console.log(state, "--state");
  const appliedDate = location.state?.appliedDate;
  const targetDate = location.state?.targetDate;
  console.log(appliedDate, targetDate, "===targetDate stae");

  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const sliceSubscriptionCode = SubscriptionCode.slice(-3);
  // const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  var recID = params.id;
  var accessID = params.accessID;
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const { toggleSidebar, broken, rtl } = useProSidebar();

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);

  const [show, setScreen] = React.useState("0");
  const EMPID = sessionStorage.getItem("EmpId");
  console.log(EMPID, "--EMPID");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  var compID = sessionStorage.getItem("companyId");
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [Fileopenstate, setFileOpenstate] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          description: Yup.string().trim().required(data.Homework.description),
          ProName: Yup.object().required(data.Homework.Standard).nullable(),
          department: Yup.object().required(data.Homework.department).nullable(),
          targetdate: Yup.string().required(data.Homework.targetdate),
          // milestone: Yup.object().required(data.Homework.Section).nullable(),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);

  //Analytics_ SECTION

  // const pieData = [
  //   { name: "Evaluated", value: 50, color: "#4CAF9F" },
  //   { name: "Pending", value: 30, color: "#F4A261" },
  //   { name: "Resubmit", value: 10, color: "#fa6579" },
  //   { name: "Yet to submit", value: 10, color: "#9E9E9E" }
  // ];

  // const barData = [
  //   { range: "0-40", value: 2 },
  //   { range: "40-60", value: 4 },
  //   { range: "60-80", value: 6 },
  //   { range: "80-90", value: 8 },
  //   { range: "80-100", value: 10 }
  // ];



  // const analyticsData = [
  //   {
  //     d: 1,
  //     RecordID: "R001",
  //     student: "Priya",
  //     section: "A Section",
  //     score: "65%",
  //     status: "Pending",
  //     eval: "5 Days Late",
  //     submission: "5 days late",
  //     remarks: "Incomplete work",
  //   },
  //   {
  //     d: 2,
  //     RecordID: "R002",
  //     student: "Guna",
  //     section: "A Section",
  //     score: "72%",
  //     status: "Evaluated",
  //     eval: "On Time",
  //     submission: "On Time",
  //     remarks: "Good",
  //   },
  //    {
  //     d: 3,
  //     RecordID: "R003",
  //     student: "Dhiya",
  //     section: "A Section",
  //     score: "32%",
  //     status: "Resubmit",
  //     eval: "On Time",
  //     submission: "On Time",
  //     remarks: "resubmit",
  //   },
  //    {
  //     d: 3,
  //     RecordID: "R004",
  //     student: "Rahul",
  //     section: "A Section",
  //     score: "95%",
  //     status: "Evaluated",
  //     eval: "On Time",
  //     submission: "On Time",
  //     remarks: "Good",
  //   },
  //    {
  //     d: 5,
  //     RecordID: "R005",
  //     student: "Arshitha",
  //     section: "A Section",
  //     score: "52%",
  //     status: "Pending",
  //     eval: "On Time",
  //     submission: "On Time",
  //     remarks: "Kindly Complete",
  //   },
  //    {
  //     d: 6,
  //     RecordID: "R006",
  //     student: "Rakshan",
  //     section: "A Section",
  //     score: "34%",
  //     status: "Resubmit",
  //     eval: "On Time",
  //     submission: "On Time",
  //     remarks: "resubmit",
  //   },
  // ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Evaluated":
        return { bg: "#2ec4b6", color: "#fff" }; // greenish
      case "Pending":
        return { bg: "#f4a261", color: "#fff" }; // orange
      case "Resubmit":
        return { bg: "#b3dac8", color: "#fff" }; // red
      case "Yet to submit":
        return { bg: "#e63946", color: "#fff" }; // red
      default:
        return { bg: "#ccc", color: "#000" };
    }
  };

  const [statusFilter, setStatusFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  //ANALYTICS_SECTION_END======================================>

  const [logoimage, setlogoimage] = useState("");
  console.log("Nowlogo", logoimage);
  //HOMEWORK_GET
  const HWteachdata = useSelector((state) => state.formApi.HWteachdata);
  console.log(HWteachdata, "-HWteachdata");

  //EVALUATION-GET=========================================
  const HWevaldata = useSelector((state) => state.formApi.HWevaldata);
  console.log(HWevaldata, "--HWevaldata");

  const studrows = HWevaldata?.grid1 || [];
  const evalrows = HWevaldata?.grid2 || [];
  const Overallrows = HWevaldata?.grid3 || [];

  //Analytics-GET=========================================
  const HWAnalyticsdata = useSelector((state) => state.formApi.HWAnalyticsdata);
  console.log(HWAnalyticsdata, "--HWAnalyticsdata");

  const pieData = HWAnalyticsdata?.pieData || [];
  const coloredPieData = pieData.map((item) => ({
    ...item,
    color: getStatusColor(item.name).bg,
  }));

  const barData = HWAnalyticsdata?.barData || [];
  console.log(barData, "--barData");

  const analyticsData = HWAnalyticsdata?.analyticsData || [];

  const filteredData = analyticsData.filter((row) => {
    const matchesStatus = statusFilter === "All" || row.Status === statusFilter;

    const matchesSearch = row.Student?.toLowerCase().includes(
      search.toLowerCase(),
    );

    return matchesStatus && matchesSearch;
  });

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;

      return (
        <div
          style={{
            background: "#04506e",
            padding: "8px 12px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            boxShadow: "0px 2px 6px rgba(245, 238, 238, 0.1)",
            fontSize: "12px",
            color: "#fff", // ✅ makes all text white
          }}
        >
          <div><strong>Students: {data.value}</strong></div>
          <div><strong>Marks: {data.range}</strong></div>
        </div>
      );
    }

    return null;
  };
  const safeBarData =
    barData && barData.length > 0
      ? barData
      : [{ range: "N/A", value: 0 }];

  const getBarColor = (range) => {
    switch (range?.trim()) {
      case "0-40":
        return "#8da9c4";

      case "40-60":
        return "#f4a261";

      case "60-80":
        return "#84a59d";

      case "80-90":
        return "#4db6ac";

      case "90-100":
        return "#2a9d8f";

      default:
        return "#ccc";
    }
  };

  //EVALUATION_ROWS_SETROWS
  const [rowsevaluation, setRowsEvaluation] = React.useState([]);

  useEffect(() => {
    if (evalrows.length > 0) {
      setRowsEvaluation(evalrows);
    }
  }, [evalrows]);

  // ✅ total
  const totalCount = evalrows.length;

  // ✅ evaluated (EV)
  const evaluatedCount = evalrows.filter((row) => row.Status === "EV").length;

  // ✅ pending (PE)
  const pendingCount = evalrows.filter((row) => row.Status === "PE").length;

  // ✅ resubmit (RS)
  const resubmitCount = evalrows.filter((row) => row.Status === "RS").length;

  // ✅ Yet to submit (YS)
  const yettosubmitCount = evalrows.filter((row) => row.Status === "YS").length;


  //EVALUATION_ROWS_SETROWS
  const [Ovrowsevaluation, OvsetRowsEvaluation] = React.useState([]);

  useEffect(() => {
    if (Overallrows.length > 0) {
      OvsetRowsEvaluation(Overallrows);
    }
  }, [Overallrows]);

  // ✅ total
  const OvtotalCount = Overallrows.length;

  // ✅ evaluated (EV)
  const OvevaluatedCount = Overallrows.filter((row) => row.Status === "EV").length;

  // ✅ pending (PE)
  const OvpendingCount = Overallrows.filter((row) => row.Status === "PE").length;

  // ✅ resubmit (RS)
  const OvresubmitCount = Overallrows.filter((row) => row.Status === "RS").length;

  // ✅ Yet to submit (YS)
  const OvyettosubmitCount = Overallrows.filter((row) => row.Status === "YS").length;


  useEffect(() => {
    if (mode === "E" && HWteachdata?.data?.length > 0) {
      setRows(HWteachdata.data);
    }
  }, [mode, HWteachdata]);

  //HEADER_GET DATA
  const data = useSelector((state) => state.formApi.Data);
  console.log(data, "--data");

  const [AssignRecID, setAssignRecID] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedPro, setSelectedPro] = useState([]);

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData,
  );
  console.log(explorelistViewData, "--explorelistViewData");

  const [rows, setRows] = React.useState([]);
  const [isGenerated, setIsGenerated] = useState(false);
  const gridRows = isGenerated ? explorelistViewData : rows;
  const [getAttach, setGetAttach] = useState(null);


  //Homework_USE_EFFECT===============
  useEffect(() => {
    console.log("MODE:", mode);

    // if (!mode) return;

    // if (mode == "E") {
    //   console.log(" Calling API");

    dispatch(
      HomeworkTeachGet({
        accessid: "TR365",
        action: "get",
        recid: recID,
        teacherID: EMPID,
        appliedDate: state.AssignedDate,

        targetDate: state.TargetedDate,
      }),
    );
  }
    // }
    , [dispatch]);

  // useEffect(() => {
  //   if (explorelistViewData?.length > 0) {
  //     setRows(explorelistViewData);
  //   }
  // }, [explorelistViewData]);

  const handleApplyClick = async (values) => {
    const projecID = selectedPro?.map((proj) => proj.RecordID).join(",");

    console.log("PROJECT ID:", projecID);
    console.log(values?.milestone?.RecordID, "--values?.milestone");
    console.log(values, "--values");
    console.log(values.Attachment, "--values.Attachment");
    setIsGenerated(true);
    // return;
    try {
      const resultAction = await dispatch(
        HomeworkGet({
          TeacherID: EMPID,
          StandardID: values?.ProName?.RecordID,
          SectionID: values?.milestone?.RecordID || 0,
          Description: values.description,
          TargetDate: values.targetdate,
          AppliedDate: selectedDate,
          DepartmentID: values?.department?.RecordID,
          Attachment: values.Attachment
            ? `/uploads/${values.Attachment}`
            : getAttach,
        }),
      );

      const payload = resultAction?.payload;
      console.log(payload, "--payload");
      setRows(resultAction?.payload?.data || []);

      return;
    } catch (error) {
      console.error("Error while applying attendance entry:", error);
      setRows([]);
    }
  };




  const handleSaveButtonClick = async (values) => {
    const dataArray = rows.map((row) => ({
      StudentID: row.StudentID || 0,
      StandardID: row.StandardID || 0,
      SectionID: row.SectionID || 0,
      Description: row.Description || "",
      TargetDate: row.TargetDate || "",
    }));

    console.log(dataArray, "--mapped data");

    const idata = {
      TeacherID: EMPID,
      StandardID: values?.ProName?.RecordID,
      // Section:values?.milestone?.map((i) => i.RecordID).join(","),
      SectionID: values?.milestone?.RecordID,
      Description: values.description,
      TargetDate: values.targetdate,
      AppliedDate: selectedDate,
      DepartmentID: values?.department?.RecordID,
      Attachment: getAttach,
      // Attachment: values.Attachment ? `/uploads/${values.Attachment}` : "",
      data: dataArray, // ✅ correct key name
      CompanyID: compID,
    };

    console.log(idata, "--Final Payload");

    // return;
    try {
      const response = await dispatch(
        wfhpostData({
          idata: idata,
        }),
      );

      if (response.payload.Status === "Y") {
        setIsGenerated(false);
        toast.success(response.payload.Msg);
        setAssignRecID(response.payload.HomeWorkID);
        if (mode == "A") {
          // dispatch(
          //   HomeworkTeachGet({
          //     accessid: "TR365",
          //     action: "get",
          //     recid: response.payload.HomeWorkID,
          //     teacherID: EMPID,
          //     appliedDate: selectedDate,
          //     targetDate: values.targetdate,
          //   }),
          // );
          navigate(-1);
          return;
        }

        // navigate(-1);
        setScreen(1);

        //for show == "1"EVALUATION_GET
        dispatch(
          HomeworkEvalGet({
            HomeWorkID: response.payload.HomeWorkID,
            TeacherID: EMPID,
          }),
        );

        OvsetRowsEvaluation(Overallrows);
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };
  const [rowModesModel, setRowModesModel] = React.useState({});

  const handleRowEditStop = (params, event) => {
    // if (params.reason === GridRowEditStopReasons.rowFocusOut) {
    event.defaultMuiPrevented = true;
    // }
  };

  const handleDeleteClick = (id) => () => {
    setRows((prevRows) => {
      const rowExists = prevRows.some((row) => row.StudentID === id);

      if (rowExists) {
        toast.success("Deleted Successfully");
      }

      return prevRows.filter((row) => row.StudentID !== id);
    });

    setRowModesModel((prevModel) => {
      const updatedModel = { ...prevModel };
      delete updatedModel[id];
      return updatedModel;
    });
  };

  const handleEditClick = (StudentID) => () => {
    console.log("--calling Editclick");

    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.Edit },
    });
  };

  const handleSaveClick = (StudentID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.View },
    });
  };

  const handleCancelClick = (StudentID) => () => {
    setRowModesModel({
      ...rowModesModel,
      [StudentID]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.StudentID === StudentID);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.StudentID !== StudentID));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRows = rows.map((row) =>
      row.StudentID === newRow.StudentID ? newRow : row,
    );

    setRows(updatedRows);
    console.log(updatedRows, "--updatedRows");
    return newRow;
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  function HomeworkTool(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rows.length > 0 ? Math.max(...rows.map((row) => row.SLNO || 0)) + 1 : 1;
      setRows((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Assignment</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  // function EditdeptAutocompleteCell(props) {
  //     const { id, value, field, api, row } = props;

  //     const handleChange = async (newValue) => {
  //       console.log("🚀 ~ Department handleChange ~ Department newValue:", newValue);
  //       if (!newValue) return;

  //       setDeptlookup(newValue);
  //       await api.setEditCellValue({
  //         id,
  //         field,
  //         value: newValue,
  //       });

  //       api.stopCellEditMode({ id, field, value: newValue });
  //     };
  //     const [deptlookup, setDeptlookup] = useState(row.Department ? row.Department : null);
  //     return (
  //       <SprintEmpAutocomplete
  //         name="Department"
  //         label="Department"
  //         id="Department"
  //         value={deptlookup}
  //         onChange={handleChange}
  //         url={`${listViewurl}?data={"Query":{"AccessID":"2149","ScreenName":"Department","Filter":"parentID=${compID}","Any":""}}`}
  //       // url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2106","ScreenName":"Scheduled To","Filter":"ERank='${row.Rank}' AND parentID='${CompanyID}'","Any":""}}`}
  //       />
  //     );
  //   }

  const AttColumn = [
    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "StudentID",
      field: "StudentID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Student",
      field: "StudentName",
      width: 150,
      align: "left",
      headerAlign: "center",
      // hide: true,
      editable: false,
    },
    {
      headerName: "StandardID",
      field: "StandardID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "SectionID",
      field: "SectionID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "TeacherID",
      field: "TeacherID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Description",
      field: "Description",
      width: 450,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: true,
    },
    //  {
    //   field: "Department",
    //   headerName: "Subjects",
    //   headerAlign: "center",
    //   width: 260,
    //   hide: false,
    //   editable: true,
    //   // sortable: false,
    //    renderCell: (params) => {
    //     return params.value?.Name || ""; // show only the name
    //   },
    //   renderEditCell: (params) => {
    //     return <EditdeptAutocompleteCell {...params} />;
    //   },
    // },
    {
      field: "TargetDate",
      headerName: "Target Date",
      headerAlign: "center",
      width: 100,
      hide: false,
      editable: false,
    },
    {
      field: "Status",
      headerName: "Status",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      // hide: isAllEV,
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              material={{
                sx: {
                  color: "primary.main",
                },
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const AttInitialvalues = {
    description: HWteachdata?.Description || "",
    targetdate: HWteachdata?.TargetDate || "",
    ProName: HWteachdata?.StandardID
      ? {
        RecordID: HWteachdata.StandardID,
        Name: HWteachdata.Standard || HWteachdata.StandardID, // fallback
      }
      : null,

    milestone: HWteachdata?.SectionID
      ? {
        RecordID: HWteachdata.SectionID,
        Name: HWteachdata.Section || HWteachdata.SectionID,
      }
      : null,
    department: HWteachdata?.DepartmentID
      ? {
        RecordID: HWteachdata.DepartmentID,
        Name: HWteachdata.Department || HWteachdata.DepartmentID,
      }
      : null,
    Attachment: HWteachdata.Attachment,
    AppliedDate: HWteachdata.AppliedDate || selectedDate,
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const handleFileUpload = async (file, params) => {
    console.log("📂 Selected file:", file);
    console.log("params", params);

    const rowId = params.id;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "images");

      const res = await dispatch(imageUpload({ formData })).unwrap();

      console.log("✅ Upload response:", res);

      const uploadedPath = res?.path || res?.name || "";
      console.log("uploadedPath", uploadedPath);
      setGetAttach(uploadedPath);
      // setRows((prevRows) =>
      //   prevRows.map((row) =>
      //     row.DT_RECID === rowId
      //       ? {
      //           ...row,
      //           AnswerSheet: uploadedPath,
      //           FileName: file.name,
      //         }
      //       : row
      //   )
      // );

      // ✅ SUCCESS TOAST
      toast.success(res?.Msg || "File uploaded successfully!");
    } catch (err) {
      console.error("❌ Upload failed:", err);
    }
  };

  //Evaluation section===========================

  const handleFileUploadEval = async (file, params) => {
    console.log("📂 Selected file:", file);
    console.log("params", params);

    const rowId = params.id;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "images");

      const res = await dispatch(imageUpload({ formData })).unwrap();

      console.log("✅ Upload response:", res);

      const uploadedPath = res?.path || res?.name || "";
      console.log("uploadedPath", uploadedPath);
      console.log(rowId, "--rowId in file upload");
      console.log(rowsevaluation, "--find rowsevaluation");


      OvsetRowsEvaluation((prevRows) =>
        prevRows.map((row) =>
          row.DT_RECID === rowId
            ? {
              ...row,
              AnswerSheet: uploadedPath,
              FileName: file.name,
            }
            : row,
        ),
      );

      // ✅ SUCCESS TOAST
      toast.success(res?.Msg || "File uploaded successfully!");
    } catch (err) {
      console.error("❌ Upload failed:", err);
    }
  };
  function StudentTool(props) {
    const { setRowsEvaluation, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rowsevaluation.length > 0
          ? Math.max(...rowsevaluation.map((row) => row.SLNO || 0)) + 1
          : 1;
      setRowsEvaluation((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Students & Assignment</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  function EvalTool(props) {
    const { setRowsEvaluation, setRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        rowsevaluation.length > 0
          ? Math.max(...rowsevaluation.map((row) => row.SLNO || 0)) + 1
          : 1;
      setRowsEvaluation((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Evaluation</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  function OvEvalTool(props) {
    const { OvsetRowsEvaluation, OvsetRowModesModel } = props;
    const handleClick = () => {
      const id = nanoid();
      const nextSLNO =
        Ovrowsevaluation.length > 0
          ? Math.max(...Ovrowsevaluation.map((row) => row.SLNO || 0)) + 1
          : 1;
      OvsetRowsEvaluation((oldRows) => [
        ...oldRows,
        {
          RecordID: id, // Temporary ID, replaced after backend save
          SLNO: nextSLNO,
          TaskID: "",
          TaskDetailRoleID: "",
          RoleCode: "",
          RoleName: "",
          TaskDetailEffort: 0,
          TaskDetailUnit: "",
          ProjectPlanedDate: "",
          isNew: true,
        },
      ]);
      OvsetRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "TaskDetailRoleID" },
      }));
    };
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h4">Homework And Evaluation</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  // const EvalColumn = [
  //   {
  //     field: "SlNo",
  //     headerName: "SL#",
  //     width: 40,
  //     hide: false,
  //     // sortable: false,
  //     // filterable: false,
  //     headerAlign: "center",
  //     align: "right",
  //     // disableColumnMenu: true,
  //     // valueGetter: (params) => {
  //     //   const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

  //     //   const totalVisibleRows = params.api.getAllRowIds().length;
  //     //   const totalAllRows = params.api.getRowsCount();

  //     //   if (totalVisibleRows < totalAllRows) {
  //     //     return index + 1;
  //     //   } else {
  //     //     return page * pageSize + index + 1;
  //     //   }
  //     // },
  //   },
  //   {
  //     headerName: "DT_RECID",
  //     field: "DT_RECID",
  //     width: 100,
  //     align: "left",
  //     headerAlign: "center",
  //     hide: true,
  //     editable: false,
  //   },
  //   {
  //     headerName: "StudentID",
  //     field: "StudentID",
  //     width: 100,
  //     align: "left",
  //     headerAlign: "center",
  //     hide: true,
  //     //   editable: false,
  //   },
  //   {
  //     headerName: "Student",
  //     field: "StudentName",
  //     width: 150,
  //     align: "left",
  //     headerAlign: "center",
  //     hide: false,
  //     editable: false,
  //   },
  //   {
  //     headerName: "HE_RECID",
  //     field: "HE_RECID",
  //     width: 100,
  //     align: "left",
  //     headerAlign: "center",
  //     hide: true,
  //     editable: false,
  //   },
  //   {
  //     field: "Score",
  //     headerName: "Score",
  //     width: 120,
  //     editable: true,

  //     valueFormatter: (params) => {
  //       if (!params.value && params.value !== 0) return "";
  //       return `${params.value} / 100`;
  //     },

  //     valueParser: (value) => {
  //       if (value === "") return "";
  //       return Number(value);
  //     },
  //   },
  //   {
  //     field: "AnswerSheet",
  //     headerName: "Answer Sheet",
  //     width: 100,
  //     editable: true,

  //     renderCell: (params) => {
  //       const fileUrl = params.row.AnswerSheet;
  //       const fileName = params.row.FileName || fileUrl?.split("/").pop();

  //       return (
  //         <Box
  //           display="flex"
  //           alignItems="center"
  //           justifyContent="space-between"
  //           width="100%"
  //         >
  //           {/* Actions */}
  //           <Box display="flex" gap={1}>
  //             {/* ✅ Upload Button */}
  //             <IconButton size="small" color="warning" component="label">
  //               <input
  //                 hidden
  //                 type="file"
  //                 accept="*/*"
  //                 onChange={(e) => {
  //                   const file = e.target.files?.[0];
  //                   if (file) {
  //                     handleFileUploadEval(file, params);
  //                   }
  //                 }}
  //               />
  //               <UploadFileIcon fontSize="small" />
  //             </IconButton>

  //             {/* ✅ Preview */}
  //             {fileUrl && (
  //               <IconButton
  //                 size="small"
  //                 color="primary"
  //                 onClick={() =>
  //                   window.open(
  //                     `${baseurl1}uploads/images/${fileUrl}`,
  //                     "_blank",
  //                   )
  //                 }
  //               >
  //                 <PreviewIcon fontSize="small" />
  //               </IconButton>
  //             )}
  //           </Box>
  //         </Box>
  //       );
  //     },

  //     renderEditCell: (params) => (
  //       <IconButton size="small" color="warning" component="label">
  //         <input
  //           hidden
  //           type="file"
  //           accept="*/*"
  //           onChange={(e) => {
  //             const file = e.target.files?.[0];
  //             if (file) {
  //               handleFileUpload(file, params);
  //             }
  //           }}
  //         />
  //         <UploadFileIcon fontSize="small" />
  //       </IconButton>
  //     ),
  //   },

  //   {
  //     field: "Status",
  //     headerName: "Status",
  //     width: 150,
  //     editable: true,
  //     type: "singleSelect",
  //     valueOptions: [
  //       { value: "EV", label: "Evaluated" },
  //       { value: "PE", label: "Pending" },
  //       { value: "RS", label: "Resubmit" },
  //       { value: "YS", label: "Yet to submit" },
  //     ],
  //     valueFormatter: (params) => {
  //       const map = {
  //         EV: "Evaluated",
  //         PE: "Pending",
  //         RS: "Resubmit",
  //         YS: "Yet to submit",
  //       };
  //       return map[params.value] || params.value;
  //     },
  //   },
  //   {
  //     field: "StatusLabel",
  //     headerName: "StatusLabel",
  //     headerAlign: "center",
  //     width: 120,
  //     hide: true,
  //     editable: false,
  //   },
  //   {
  //     field: "EvaluatedBy",
  //     headerName: "EvaluatedBy",
  //     headerAlign: "center",
  //     width: 120,
  //     hide: true,
  //     editable: false,
  //   },
  //   {
  //     field: "EvaluatedOn",
  //     headerName: "EvaluatedOn",
  //     headerAlign: "center",
  //     width: 120,
  //     hide: true,
  //     editable: false,
  //   },
  //   {
  //     field: "Remarks",
  //     headerName: "Remarks",
  //     headerAlign: "center",
  //     width: 300,
  //     editable: true,
  //     hide: false,
  //     // renderCell: (params) => (
  //     //   <Typography>{params.row.Remarks || "—"}</Typography>
  //     // ),
  //   },
  // ];
  const EvalColumn1 = [
    {
      field: "SlNo",
      headerName: "SL#",
      width: 40,
      hide: false,
      // sortable: false,
      // filterable: false,
      headerAlign: "center",
      align: "right",
      // disableColumnMenu: true,
      // valueGetter: (params) => {
      //   const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

      //   const totalVisibleRows = params.api.getAllRowIds().length;
      //   const totalAllRows = params.api.getRowsCount();

      //   if (totalVisibleRows < totalAllRows) {
      //     return index + 1;
      //   } else {
      //     return page * pageSize + index + 1;
      //   }
      // },
    },
    {
      headerName: "DT_RECID",
      field: "DT_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "StudentID",
      field: "StudentID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      //   editable: false,
    },
    {
      headerName: "Student",
      field: "StudentName",
      width: 150,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      headerName: "HE_RECID",
      field: "HE_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      field: "Score",
      headerName: "Score",
      width: 120,
      editable: true,

      valueFormatter: (params) => {
        if (!params.value && params.value !== 0) return "";
        return `${params.value} / 100`;
      },

      valueParser: (value) => {
        if (value === "") return "";
        return Number(value);
      },
    },
    {
      field: "AnswerSheet",
      headerName: "Answer Sheet",
      width: 100,
      editable: true,

      renderCell: (params) => {
        const fileUrl = params.row.AnswerSheet;
        const fileName = params.row.FileName || fileUrl?.split("/").pop();
        console.log(params.row.AnswerSheet, "--fileurl");

        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            {/* Actions */}
            <Box display="flex" gap={1}>
              {/* ✅ Upload Button */}
              <IconButton size="small" color="warning" component="label">
                <input
                  hidden
                  type="file"
                  accept="*/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      handleFileUploadEval(file, params);
                    }
                  }}
                />
                <UploadFileIcon fontSize="small" />
              </IconButton>

              {/* ✅ Preview */}
              {fileUrl && (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() =>
                    window.open(
                      `${baseurl1}uploads/images/${fileUrl}`,
                      "_blank",
                    )
                  }
                >
                  <PreviewIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },

      renderEditCell: (params) => (
        <IconButton size="small" color="warning" component="label">
          <input
            hidden
            type="file"
            accept="*/*"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                handleFileUpload(file, params);
              }
            }}
          />
          <UploadFileIcon fontSize="small" />
        </IconButton>
      ),
    },

    {
      field: "Status",
      headerName: "Status",
      width: 150,
      editable: true,
      type: "singleSelect",
      valueOptions: [
        { value: "EV", label: "Evaluated" },
        { value: "PE", label: "Pending" },
        // { value: "RS", label: "Resubmit" },
        { value: "YS", label: "Yet to submit" },
      ],
      renderEditCell: (params) => {
        return (
          <Select
            autoFocus
            value={params.value ?? ""}
            onChange={(e) => {
              const value = e.target.value;

              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value,
              });

              params.api.stopCellEditMode({
                id: params.id,
                field: params.field,
              });
            }}
            // variant="standard"
            fullWidth
            sx={{
              height: "100%",
              fontSize: "0.875rem",
            }}
          >
            <MenuItem value="EV">Evaluated</MenuItem>
            <MenuItem value="PE">Pending</MenuItem>
            {/* <MenuItem value="RS">Resubmit</MenuItem> */}
            <MenuItem value="YS">Yet to submit</MenuItem>
          </Select>
        );
      },

      valueFormatter: (params) => {
        const map = {
          EV: "Evaluated",
          PE: "Pending",
          RS: "Resubmit",
          YS: "Yet to submit",
        };
        return map[params.value] || params.value;
      },
    },
    {
      field: "StatusLabel",
      headerName: "StatusLabel",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
    {
      field: "EvaluatedBy",
      headerName: "EvaluatedBy",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
    {
      field: "EvaluatedOn",
      headerName: "EvaluatedOn",
      headerAlign: "center",
      width: 120,
      hide: true,
      editable: false,
    },
    {
      field: "Remarks",
      headerName: "Remarks",
      headerAlign: "center",
      width: 300,
      editable: true,
      hide: false,
      renderEditCell: (params) => {
        return (
          <input
            autoFocus
            value={params.value ?? ""}
            onChange={(e) => {
              const value = e.target.value;

              // ✅ update instantly
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value,
              });
            }}
            onBlur={() => {
              // ✅ commit when leaving (safe)
              params.api.stopCellEditMode({
                id: params.id,
                field: params.field,
              });
            }}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              outline: "none",
              fontSize: "0.875rem",
              background: "transparent",
            }}
          />
        );
      },
      // renderCell: (params) => (
      //   <Typography>{params.row.Remarks || "—"}</Typography>
      // ),
    },
  ];

  const StudColumn = [
    {
      field: "SlNo",
      headerName: "SL#",
      width: 40,
      //   editable: false,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "right",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    {
      headerName: "DT_RECID",
      field: "DT_RECID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "StudentID",
      field: "StudentID",
      width: 100,
      align: "left",
      headerAlign: "center",
      hide: true,
      editable: false,
    },
    {
      headerName: "Student",
      field: "StudentName",
      width: 150,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },

    {
      headerName: "Description",
      field: "Description",
      width: 350,
      align: "left",
      headerAlign: "center",
      hide: false,
      editable: false,
    },
    {
      field: "TargetDate",
      headerName: "Target Date",
      headerAlign: "center",
      width: 100,
      hide: false,
      editable: false,
    },
    {
      field: "AssignStatus",
      headerName: "AssignStatus",
      headerAlign: "center",
      width: 100,
      hide: true,
      editable: false,
    },

    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Actions",
    //   width: 100,
    //   cellClassName: "actions",
    //   getActions: ({ id }) => {
    //     const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

    //     if (isInEditMode) {
    //       return [
    //         <GridActionsCellItem
    //           icon={<SaveIcon />}
    //           label="Save"
    //           material={{
    //             sx: {
    //               color: "primary.main",
    //             },
    //           }}
    //           onClick={handleSaveClick(id)}
    //         />,
    //         <GridActionsCellItem
    //           icon={<CancelIcon />}
    //           label="Cancel"
    //           className="textPrimary"
    //           onClick={handleCancelClick(id)}
    //           color="inherit"
    //         />,
    //       ];
    //     }

    //     return [
    //       <GridActionsCellItem
    //         icon={<EditIcon />}
    //         label="Edit"
    //         className="textPrimary"
    //         onClick={handleEditClick(id)}
    //         color="inherit"
    //       />,
    //       <GridActionsCellItem
    //         icon={<DeleteIcon />}
    //         label="Delete"
    //         onClick={handleDeleteClick(id)}
    //         color="inherit"
    //       />,
    //     ];
    //   },
    // },
  ];
  const handleSaveButtonClickHWEval = async (values) => {
    console.log(AssignRecID, "--AssignRecID");
    // VALIDATION START
    // const hasError = rowsevaluation.some((row) => {
    // // 2️⃣ If Score entered → AnswerSheet required
    //   if (row.Score && !row.AnswerSheet) {
    //     toast.error(
    //       `Upload Answer Sheet before entering Score for ${row.StudentName}`
    //     );
    //     return true;
    //   }

    //   // 1️⃣ Status must be selected (not default "Yet to submit")
    //   // if (!row.Status || row.Status === "YS") {
    //   //   toast.error(`Please select Status for ${row.StudentName}`);
    //   //   return true;
    //   // }

    //   // 3️⃣ Score range validation
    //   if (
    //     row.Score !== "" &&
    //     row.Score !== null &&
    //     (row.Score < 0 || row.Score > 100)
    //   ) {
    //     toast.error(
    //       `Score must be between 0 and 100 for ${row.StudentName}`
    //     );
    //     return true;
    //   }

    //   return false;
    // });

    // 🚫 STOP API if validation fails
    // if (hasError) return;

    // ✅ VALIDATION END
    const dataArray = Ovrowsevaluation.map((row) => ({
      DailyTaskID: row.DT_RECID || 0,
      StudentID: row.StudentID || 0,
      Score: row.Score || 0,
      AnswerSheet: row.AnswerSheet || row.FileName || "",
      //     AnswerSheet:
      // row.FileName ||
      // (row.AnswerSheet ? row.AnswerSheet.split("/").pop() : ""),
      Remarks: row.Remarks || "",
      Status: row.Status || "",
    }));

    console.log(dataArray, "--mapped data");

    const idata = {
      StandardID: values?.ProName?.RecordID,
      // Section:values?.milestone?.map((i) => i.RecordID).join(","),
      SectionID: values?.milestone?.RecordID,
      HomeWorkID: AssignRecID ? AssignRecID : recID,
      CompanyID: compID,
      TeacherID: EMPID,
      data: dataArray, // ✅ correct key name
    };

    console.log(idata, "--Final Payload");

    // return;
    try {
      const response = await dispatch(
        HomeworkEvalPOST({
          idata: idata,
        }),
      );

      if (response.payload.Status === "Y") {
        console.log(response.payload.Msg, "--console the msg");
        toast.success(response.payload.Msg);
        navigate(-1);
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      toast.error("Error occurred during save.");
    }
  };
  const screenChange = async (event) => {
    setScreen(event.target.value);
    setRows([]);
    if (event.target.value == "0") {
      dispatch(
        HomeworkTeachGet({
          accessid: "TR365",
          action: "get",
          recid: recID,
          teacherID: EMPID,
          appliedDate: state.AssignedDate,
          targetDate: state.TargetedDate,
        }),
      );
    }
    if (event.target.value == "1") {
      console.log("--calling show1");
      // console.log(evalrows.length, "--evalrows.length");
      // console.log(evalrows, "--evalrows");
      // console.log(AssignRecID, "--AssignRecID in Screen 1");
      console.log(Overallrows.length, "--Overallrows.length");
      console.log(Overallrows, "--Overallrows");
      console.log(AssignRecID, "--AssignRecID in Screen 1");

      dispatch(
        HomeworkEvalGet({
          HomeWorkID: recID,
          TeacherID: EMPID,
        }),
      );

      // if (evalrows.length > 0) {
      console.log(Overallrows, "--rowsevaluation");
      OvsetRowsEvaluation(Overallrows);
      // }
    }
    if (event.target.value == "2") {
      console.log("Analytics selected");
      dispatch(
        HomeworkEvalAnalyticsGet({
          HomeworkID: recID,
          CompanyID: compID,
        }),
      );
      // Optional: load analytics data here
    }
  };

  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>

          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                {/* First Item */}
                <Typography
                  onClick={() => {
                    setScreen(0);
                    dispatch(
                      HomeworkTeachGet({
                        accessid: "TR365",
                        action: "get",
                        recid: recID,
                        teacherID: EMPID,
                        appliedDate: state.AssignedDate,
                        targetDate: state.TargetedDate,
                      }),
                    );
                  }}
                  variant="h5"
                  sx={{
                    color: "#0000D1",
                    fontSize: "19px",
                    cursor: "pointer", // 👈 default cursor
                    "&:hover": {
                      color:"#0000D1", // optional hover color
                    },
                  }}
                >
                  {mode === "A" && show == "1" ? "Evaluation" : "Homework"}
                  {/* {mode === "E" ? "Homework" : "Evaluation"} */}
                </Typography>
                {mode === "E" && show == "1" ? (
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#0000D1",
                      fontSize: "19px",
                    }}
                  >
                    Evaluation
                  </Typography>
                ) : null}
                {mode === "E" && show == "2" ? (
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#0000D1",
                      fontSize: "19px",
                    }}
                  >
                    Analytics
                  </Typography>
                ) : null}
              </Breadcrumbs>
            </Box>
          </Box>

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Homework</MenuItem>
                  <MenuItem value={1}>Evaluation</MenuItem>
                  {/* <MenuItem value={2}>Analytics</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}

            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {show == "0" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={AttInitialvalues}
            // initialValues={
            //   mode === "E"
            //     ? AttInitialvalues
            //     : {
            //       ProName: null,
            //       milestone: null,
            //       description: "",
            //       targetdate: "",
            //       Attachment: getAttach,
            //       department: null,

            //       // add all required fields here
            //     }
            // }
            // enableReinitialize={mode == "A" ? false : true}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                handleApplyClick(values); // ✅ only runs if valid
                // attendaceFnSave(values, resetForm);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  resetForm();

                  // ✅ Clear DataGrid rows
                  setRows([]);
                  dispatch(resetTrackingData());
                }}
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                  // gap="70px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <Stack direction="row" spacing={2}> */}

                  <TextField
                    name="date"
                    type="date"
                    label="Date"
                    variant="standard"
                    focused
                    // value={selectedDate}
                    value={values.AppliedDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ span: 2 }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    name="targetdate"
                    type="date"
                    // label="Target Date"
                    label={
                      <>
                        Target Date
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    value={values.targetdate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.targetdate && !!errors.targetdate}
                    helperText={touched.targetdate && errors.targetdate}
                    sx={{ span: 2 }}
                  />

                  <CheckinAutocomplete
                    sx={{ span: 2 }}
                    name="ProName"
                    label={
                      <>
                        Standard
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="ProName"
                    value={values.ProName}
                    onChange={(newValue) => {
                      setFieldValue("ProName", newValue);
                    }}
                    error={!!touched.ProName && !!errors.ProName}
                    helperText={touched.ProName && errors.ProName}
                    disabled={mode === "E" ? true : false}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2119",
                          ScreenName: "Project",
                          Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                  />

                  {/* <CheckinAutocomplete
                    sx={{ span: 2 }}
                    name="milestone"
                    label={
                      <>
                        Section
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="milestone"
                    value={values.milestone}
                    onChange={(newValue) => {
                      setFieldValue("milestone", newValue);
                    }}
                    error={!!touched.milestone && !!errors.milestone}
                    helperText={touched.milestone && errors.milestone}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2105",
                          ScreenName: "Milestone",
                          Filter: `parentID='${values.ProName?.RecordID}' AND CompanyID='${compID}'`,
                          Any: "",
                          VerticalLicense:is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                  /> */}

                  <CheckinAutocomplete
                    sx={{
                      span: 2,

                    }}
                    name="department"
                    label={
                      <>
                        Subject
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="department"
                    value={values.department}
                    onChange={(newValue) => {
                      setFieldValue("department", newValue);
                      console.log(newValue, "--deartment newValue");
                    }}
                    error={!!touched.department && !!errors.department}
                    helperText={touched.department && errors.department}
                    disabled={mode === "E" ? true : false}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2149",
                          ScreenName: "Department",
                          // Filter: `ProjectID=${values.ProName?.RecordID || 0} AND AssignedBy=${EMPID}`,
                          Filter: `ProjectID='${values.ProName?.RecordID ?? 0}' AND parentID=${compID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                  />
                  {/* LEFT SIDE */}
                  <TextField
                    name="description"
                    type="text"
                    label="Description"
                    label={
                      <>
                        Description
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    variant="standard"
                    focused
                    // required
                    value={values.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    sx={{ span: 2 }} // adjust width as needed
                  />

                  {/* </Stack> */}
                </Box>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  padding={1}
                  width="100%"
                >
                  {/* RIGHT SIDE BUTTON GROUP */}
                  <Stack direction="row" spacing={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <IconButton
                        size="small"
                        color="warning"
                        component="label"
                      >
                        <input
                          hidden
                          type="file"
                          accept="*/*"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              handleFileUpload(file, params);
                            }
                            console.log(params, "--file onchange time");

                          }}
                        />
                        <UploadFileIcon fontSize="small" />
                      </IconButton>

                      {/* File Name */}
                      {/* {(getAttach || HWteachdata.Attachment) && (
  <Typography variant="body2">
    {getAttach || HWteachdata.Attachment}
  </Typography>
)} */}
                      {(getAttach || HWteachdata.Attachment) ? (
                        <Typography variant="body2">
                          {mode == "A" ? ("" || getAttach) : (getAttach || HWteachdata.Attachment)}
                        </Typography>

                      ) : (
                        false
                      )}

                      {/* {(mode === "A" ? getAttach : (getAttach || HWteachdata.Attachment)) && (
  <Typography variant="body2">
    {mode === "A"
      ? getAttach
      : (getAttach || HWteachdata.Attachment)}
  </Typography>
)} */}

                      {/* ✅ View button ONLY in Edit mode */}
                      {/* // mode == "E" && 
                      // HWteachdata.Attachment && ( */}
                      {/* {params.row.Attachment && ( */}
                      {(getAttach || HWteachdata.Attachment) && (
                        <Tooltip title="View File">
                          <IconButton
                            color="primary"
                            onClick={() =>

                              window.open(
                                `${baseurl1}uploads/images/${getAttach ?? HWteachdata.Attachment}`,
                                "_blank",
                              )
                            }
                          >
                            <PreviewIcon />
                          </IconButton>
                        </Tooltip>
                      )}


                    </Box>


                    <Button
                      variant="contained"
                      color="secondary"
                      type="submit"
                      // onClick={() => handleApplyClick(values)}
                      disabled={mode === "E" ? true : false}
                    >
                      Assign
                    </Button>

                    <Button
                      type="reset"
                      variant="contained"
                      color="error"
                      size="small"
                    >
                      Reset
                    </Button>
                  </Stack>
                </Stack>
                <Box sx={{ gridColumn: "span 4" }}>
                  <Box
                    height="420px"
                    margin={1}
                    // height={dataGridHeight}
                    //  marginTop={2}
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={rows}
                      columns={AttColumn}
                      editMode="cell"
                      isCellEditable={(params) => {
                        const isInEditMode =
                          rowModesModel[params.id]?.mode === GridRowModes.Edit;

                        // Enable editing only for the Description column when row is in edit mode
                        if (isInEditMode && params.field === "Description") {
                          return true;
                        }
                        //                      if (
                        //   isInEditMode &&
                        //   (params.field === "Description" || params.field === "Department")
                        // ) {
                        //   return true;
                        // }

                        return false;
                      }}
                      disableSelectionOnClick
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      getRowId={(row) => row.StudentID}
                      disableRowSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                      onProcessRowUpdateError={(error) => {
                        console.error(
                          "Row update validation failed:",
                          error.message,
                        );

                        toast.error(error.message);
                      }}
                      components={{
                        Toolbar: HomeworkTool,
                      }}
                      componentsProps={{
                        toolbar: { setRows, setRowModesModel },
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  mt="15px"
                  gap="20px"
                  padding={1}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    padding="15px"
                    gap={formGap}
                  >
                    <Button
                      type="submit"
                      color="secondary"
                      variant="contained"
                      // loading={isLoading}
                      onClick={() => handleSaveButtonClick(values)}
                      disabled={mode === "E" ? true : false}
                    >
                      Save
                    </Button>
                    <Button
                      color="warning"
                      variant="contained"
                      // loading={isLoading}
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={AttInitialvalues}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                // attendaceFnSave(values, resetForm);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  resetForm();

                  // ✅ Clear DataGrid rows
                  setRows([]);
                  dispatch(resetTrackingData());
                }}
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                  // gap="70px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <Stack direction="row" spacing={2}> */}

                  <TextField
                    name="date"
                    type="date"
                    label="Date"
                    variant="standard"
                    focused
                    // value={selectedDate}
                    value={values.AppliedDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ span: 2 }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    name="targetdate"
                    type="date"
                    label="Target Date"
                    variant="standard"
                    focused
                    value={values.targetdate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.targetdate && !!errors.targetdate}
                    helperText={touched.targetdate && errors.targetdate}
                    sx={{ span: 2 }}
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="ProName"
                    label={
                      <>
                        Standard
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="ProName"
                    value={values.ProName}
                    onChange={(newValue) => {
                      setFieldValue("ProName", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2119",
                          ScreenName: "Project",
                          Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Standard"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />

                  {/* <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="milestone"
                    label={
                      <>
                        Section
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="milestone"
                    value={values.milestone}
                    onChange={(newValue) => {
                      setFieldValue("milestone", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2105",
                          ScreenName: "Milestone",
                          Filter: `parentID='${values.ProName?.RecordID}' AND CompanyID='${compID}'`,
                          Any: "",
                          VerticalLicense:is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Milestone"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  /> */}
                  <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="department"
                    label={
                      <>
                        Subject
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="department"
                    value={values.department}
                    onChange={(newValue) => {
                      setFieldValue("department", newValue);
                      console.log(newValue, "--deartment newValue");
                    }}
                    error={!!touched.department && !!errors.department}
                    helperText={touched.department && errors.department}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2149",
                          ScreenName: "Department",
                          Filter: `parentID=${compID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Subject"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />
                  {/* LEFT SIDE */}
                  <TextField
                    name="description"
                    type="text"
                    label="Description"
                    variant="standard"
                    focused
                    value={values.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    sx={{ span: 2 }}
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  {/* </Stack> */}
                </Box>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  padding={1}
                  width="100%"
                >
                  {/* RIGHT SIDE BUTTON GROUP */}
                  <Stack direction="row" spacing={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {
                        // mode == "EV" &&
                        HWevaldata.Attachment && (
                          <Tooltip title="Homework View File">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() =>
                                window.open(
                                  `${baseurl1}uploads/images/${HWevaldata.Attachment}`,
                                  "_blank",
                                )
                              }
                            >
                              <PreviewIcon />
                            </IconButton>
                          </Tooltip>
                        )
                      }
                    </Box>
                  </Stack>
                </Stack>
                {/* SUMMARY CARDS */}
                <Box display="flex" gap={2} padding={1} flexWrap="wrap">
                  {/* TOTAL */}
                  <Paper
                    sx={{
                      p: 2,
                      minWidth: 120,
                      textAlign: "center",
                      background: "#f1efea",
                    }}
                  >
                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                      {OvtotalCount}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      TOTAL
                    </Typography>
                  </Paper>

                  {/* EVALUATED */}
                  <Paper
                    sx={{
                      p: 2,
                      minWidth: 120,
                      textAlign: "center",
                      background: "#f1efea",
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="green"
                      sx={{ fontWeight: "bold" }}
                    >
                      {OvevaluatedCount}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      EVALUATED
                    </Typography>
                  </Paper>

                  {/* PENDING */}
                  <Paper
                    sx={{
                      p: 2,
                      minWidth: 120,
                      textAlign: "center",
                      background: "#f1efea",
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="orange"
                      sx={{ fontWeight: "bold" }}
                    >
                      {OvpendingCount}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      PENDING
                    </Typography>
                  </Paper>

                  {/* RESUBMIT */}
                  {/* <Paper
                    sx={{
                      p: 2,
                      minWidth: 120,
                      textAlign: "center",
                      background: "#f1efea",
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="red"
                      sx={{ fontWeight: "bold" }}
                    >
                      {OvresubmitCount}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      RESUBMIT
                    </Typography>
                  </Paper> */}

                  {/* Yet to submit */}
                  <Paper
                    sx={{
                      p: 2,
                      minWidth: 120,
                      textAlign: "center",
                      background: "#f1efea",
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="#9E9E9E"
                      sx={{ fontWeight: "bold" }}
                    >
                      {OvyettosubmitCount}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {/* Yet to submit */}
                      YET TO SUBMIT
                    </Typography>
                  </Paper>
                </Box>

                {/* /*Datagrid*/}
                {/* <Box sx={{ gridColumn: "span 4", display: "flex", gap: 2 }}>
                  <Box
                    flex={1}
                    height="420px"
                    margin={1}
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      // rows={rows}
                      rows={studrows}
                      columns={StudColumn}
                      disableSelectionOnClick
                      getRowId={(row) => row.StudentID}
                      disableRowSelectionOnClick
                      components={{
                        Toolbar: StudentTool,
                      }}
                      // componentsProps={{
                      //   toolbar: { setRows, setRowModesModel },
                      // }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                  <Box
                    flex={1}
                    height="420px"
                    margin={1}
                    // height={dataGridHeight}
                    //  marginTop={2}
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={rowsevaluation}
                      columns={EvalColumn}
                      editMode="cell" // ✅ enables double click editing
                      isCellEditable={(params) =>
                        ["Score", "Remarks", "Status", "AnswerSheet"].includes(
                          params.field,
                        )
                      }
                      processRowUpdate={(newRow) => {
                        // 🚫 Validation before saving
                        if (newRow.Score && !newRow.AnswerSheet) {
                          toast.error(
                            "Upload Answer Sheet before updating Score",
                          );
                          return newRow;
                        }

                        if (
                          newRow.Score &&
                          (newRow.Score < 0 || newRow.Score > 100)
                        ) {
                          toast.error("Score must be between 0 and 100");
                          return newRow;
                        }
                        const updatedRows = rowsevaluation.map((row) =>
                          row.DT_RECID === newRow.DT_RECID ? newRow : row,
                        );

                        setRowsEvaluation(updatedRows);
                        console.log(updatedRows, "--updatedRows");

                        return newRow;
                      }}
                      getRowId={(row) => row.DT_RECID}
                      disableSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                      onProcessRowUpdateError={(error) => {
                        console.error(error);
                        toast.error(error.message);
                      }}
                      components={{
                        Toolbar: EvalTool,
                      }}
                      componentsProps={{
                        toolbar: { setRowsEvaluation, setRowModesModel },
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                </Box> */}
                <Box sx={{ gridColumn: "span 4", display: "flex", gap: 2 }}>
                  <Box
                    flex={1}
                    height="420px"
                    margin={1}
                    // height={dataGridHeight}
                    //  marginTop={2}
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={Ovrowsevaluation}
                      columns={EvalColumn1}
                      editMode="cell" // ✅ enables double click editing
                      isCellEditable={(params) =>
                        ["Score", "Remarks", "Status", "AnswerSheet"].includes(
                          params.field,
                        )
                      }
                      processRowUpdate={(newRow) => {
                        // 🚫 Validation before saving
                        // if (newRow.Score && !newRow.AnswerSheet) {
                        //   toast.error(
                        //     "Upload Answer Sheet before updating Score",
                        //   );
                        //   return newRow;
                        // }

                        if (
                          // newRow.Score 
                          // &&
                          (newRow.Score < 0 || newRow.Score > 100)
                        ) {
                          toast.error("Score must be between 0 and 100");
                          return newRow;
                        }
                        // const updatedRows = rowsevaluation.map((row) =>
                        //   row.DT_RECID === newRow.DT_RECID ? newRow : row,
                        // );

                        // setRowsEvaluation(updatedRows);
                        OvsetRowsEvaluation((prevRows) =>
                          prevRows.map((row) =>
                            row.DT_RECID === newRow.DT_RECID ? newRow : row
                          )
                        );
                        // console.log(updatedRows, "--updatedRows");

                        return newRow;
                      }}
                      getRowId={(row) => row.DT_RECID}
                      onCellEditCommit={(params) => {
                        OvsetRowsEvaluation((prev) =>
                          prev.map((row) =>
                            row.DT_RECID === params.id
                              ? { ...row, [params.field]: params.value }
                              : row
                          )
                        );
                      }}
                      disableSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                      onProcessRowUpdateError={(error) => {
                        console.error(error);
                        toast.error(error.message);
                      }}
                      components={{
                        Toolbar: OvEvalTool,
                      }}
                      componentsProps={{
                        toolbar: { setRowsEvaluation, setRowModesModel },
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      pagination
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPage) => setPage(newPage)}
                    />
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  mt="15px"
                  gap="20px"
                  padding={1}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    padding="15px"
                    gap={formGap}
                  >
                    <Button
                      type="submit"
                      color="secondary"
                      variant="contained"
                      // loading={isLoading}
                      onClick={() => handleSaveButtonClickHWEval(values)}
                    >
                      Save
                    </Button>
                    <Button
                      color="warning"
                      variant="contained"
                      // loading={isLoading}
                      onClick={() => {
                        setScreen(0);
                        dispatch(
                          HomeworkTeachGet({
                            accessid: "TR365",
                            action: "get",
                            recid: recID,
                            teacherID: EMPID,
                            appliedDate: state.AssignedDate,
                            targetDate: state.TargetedDate,
                          }),
                        );
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "2" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={AttInitialvalues}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                // attendaceFnSave(values, resetForm);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  resetForm();

                  // ✅ Clear DataGrid rows
                  setRows([]);
                  dispatch(resetTrackingData());
                }}
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                  // gap="70px"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <Stack direction="row" spacing={2}> */}

                  <TextField
                    name="date"
                    type="date"
                    label="Date"
                    variant="standard"
                    focused
                    value={selectedDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ span: 2 }}
                  />

                  <TextField
                    name="targetdate"
                    type="date"
                    label="Target Date"
                    variant="standard"
                    focused
                    value={values.targetdate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.targetdate && !!errors.targetdate}
                    helperText={touched.targetdate && errors.targetdate}
                    sx={{ span: 2 }}
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="ProName"
                    label={
                      <>
                        Standard
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="ProName"
                    value={values.ProName}
                    onChange={(newValue) => {
                      setFieldValue("ProName", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2119",
                          ScreenName: "Project",
                          Filter: `parentID=${compID} AND EmployeeID=${EMPID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Standard"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />

                  <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="milestone"
                    label={
                      <>
                        Section
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="milestone"
                    value={values.milestone}
                    onChange={(newValue) => {
                      setFieldValue("milestone", newValue);
                    }}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2105",
                          ScreenName: "Milestone",
                          Filter: `parentID='${values.ProName?.RecordID}' AND CompanyID='${compID}'`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Milestone"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />
                  <CheckinAutocomplete
                    disabled={mode == "E"}
                    sx={{ span: 2 }}
                    name="department"
                    label={
                      <>
                        Subject
                        <span style={{ color: "red", fontSize: "20px" }}>
                          {" "}
                          *
                        </span>
                      </>
                    }
                    id="department"
                    value={values.department}
                    onChange={(newValue) => {
                      setFieldValue("department", newValue);
                      console.log(newValue, "--deartment newValue");
                    }}
                    error={!!touched.department && !!errors.department}
                    helperText={touched.department && errors.department}
                    url={`${listViewurl}?data=${encodeURIComponent(
                      JSON.stringify({
                        Query: {
                          AccessID: "2149",
                          ScreenName: "Department",
                          Filter: `parentID=${compID}`,
                          Any: "",
                          VerticalLicense: is003Subscription ? sliceSubscriptionCode : ""
                        },
                      }),
                    )}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Subject"
                        variant="standard"
                        InputProps={{
                          ...params.InputProps,
                          readOnly: true,
                        }}
                      />
                    )}
                  />
                  {/* LEFT SIDE */}
                  <TextField
                    name="description"
                    type="text"
                    label="Description"
                    variant="standard"
                    focused
                    value={values.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    sx={{ span: 2 }}
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  {/* </Stack> */}
                </Box>

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  padding={1}
                  width="100%"
                >
                  {/* RIGHT SIDE BUTTON GROUP */}
                  <Stack direction="row" spacing={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {
                        // mode == "EV" &&
                        HWevaldata.Attachment && (
                          <Tooltip title="Homework View File">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() =>
                                window.open(
                                  `${baseurl1}uploads/images/${HWevaldata.Attachment}`,
                                  "_blank",
                                )
                              }
                            >
                              <PreviewIcon />
                            </IconButton>
                          </Tooltip>
                        )
                      }
                    </Box>
                  </Stack>
                </Stack>
                <Box p={3} bgcolor="#f5f6fa" minHeight="100vh">
                  <Grid container spacing={3}>

                    <Grid item xs={12} md={4}>
                      <Card sx={{ borderRadius: 3 }}>
                        <CardContent>
                          <Typography variant="h4" fontWeight={600}>
                            Submission
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            All Sections
                          </Typography>
                          <Box height={160}>
                            <ResponsiveContainer>
                              <PieChart>
                                <Pie
                                  data={coloredPieData}
                                  innerRadius={60}
                                  outerRadius={80}
                                  dataKey="value"
                                >
                                  {coloredPieData.map((entry, index) => (
                                    <Cell key={index} fill={entry.color} />
                                  ))}
                                </Pie>
                              </PieChart>
                            </ResponsiveContainer>
                          </Box>
                          {coloredPieData.map((item, i) => (
                            <Box
                              key={i}
                              display="flex"
                              justifyContent="space-between"
                              mb={1}
                            >
                              <Box display="flex" alignItems="center" gap={1}>
                                <Box
                                  width={10}
                                  height={10}
                                  borderRadius="50%"
                                  bgcolor={item.color}
                                />
                                <Typography variant="body2">{item.name}</Typography>
                              </Box>
                              <Typography variant="body2" fontWeight={500}>
                                {item.value}
                              </Typography>
                            </Box>
                          ))}

                          <Box mt={2} display="flex" justifyContent="space-between">
                            <Typography variant="body2">Avg. Score</Typography>
                            <Chip label="35" color="success" size="medium" />
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>


                    {/* RIGHT CARD */}
                    <Grid item xs={12} md={8}>
                      <Card sx={{ borderRadius: 3 }}>
                        <CardContent>
                          <Box display="flex" justifyContent="space-between" mb={2}>
                            <Box>
                              <Typography variant="h4" fontWeight={600}>
                                Score
                              </Typography>
                              {/* <Typography variant="body2" color="text.secondary">
                    Score Breaks: 9 students
                  </Typography> */}
                            </Box>

                            <Select size="small" defaultValue="avg">
                              <MenuItem value="avg">Average 35</MenuItem>
                            </Select>
                          </Box>


                          <Box height={280}>
                            {/* <ResponsiveContainer>
                  <BarChart data={safeBarData}>
                  <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="range" />
                    <YAxis domain={[0, 'dataMax + 1']} />
                      <RechartsTooltip />
                  
                <Bar
  dataKey="value"
  radius={[6, 6, 0, 0]}
  barSize={30}
  label={{ position: "top" }}
>
  {safeBarData.map((entry, index) => (
    <Cell
      key={`cell-${index}`}
      fill={getBarColor(entry.range)}
    />
  ))}
</Bar>
                  </BarChart>
                </ResponsiveContainer> */}
                            <ResponsiveContainer>
                              <BarChart data={safeBarData}>
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                  dataKey="range"
                                  interval={0}
                                />

                                <YAxis
                                  allowDecimals={false}
                                  tickCount={100}
                                  domain={[0, (dataMax) => Math.max(dataMax + 1, 1)]}
                                />

                                {/* <RechartsTooltip /> */}
                                <RechartsTooltip content={<CustomTooltip />} cursor={false} />


                                <Bar
                                  dataKey="value"
                                  radius={[6, 6, 0, 0]}
                                  barSize={40}
                                  minPointSize={3}
                                  label={{ position: "top" }}
                                >
                                  {safeBarData.map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={getBarColor(entry.range)}
                                    />
                                  ))}
                                </Bar>

                              </BarChart>
                            </ResponsiveContainer>
                          </Box>

                        </CardContent>
                      </Card>
                    </Grid>
                    {/* //GRID_SECTION */}
                    <Box
                      p={3}
                      mt={2}
                      sx={{
                        minHeight: "100vh",
                        background:
                          "linear-gradient(to right, #fdfbfb, #ebedee)",
                      }}
                      //  bgcolor="#f5f6fa"
                      minHeight="100vh"
                      width="100%"
                    >
                      <Card sx={{ borderRadius: 3 }}>
                        <CardContent>
                          {/* Header */}
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            mb={2}
                          >
                            <Grid item xs={12} md={6}>
                              <Typography variant="h4" fontWeight={600}>
                                Evaluation
                              </Typography>
                            </Grid>

                            <Grid item xs={6} md={3}>
                              <Select
                                fullWidth
                                size="small"
                                value={statusFilter}
                                onChange={(e) =>
                                  setStatusFilter(e.target.value)
                                }
                              >
                                <MenuItem value="All">All</MenuItem>
                                <MenuItem value="PE">Pending</MenuItem>
                                <MenuItem value="EV">Evaluated</MenuItem>
                                <MenuItem value="RS">Resubmit</MenuItem>
                                <MenuItem value="YS">Yet to submit</MenuItem>
                              </Select>
                            </Grid>

                            <Grid item xs={6} md={3}>
                              <TextField
                                fullWidth
                                size="small"
                                placeholder="Search student..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                          </Grid>

                          {/* Table */}
                          <Table>
                            <TableHead
                              sx={{
                                backgroundColor: "#32cfc3",
                              }}
                            >
                              <TableRow>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Rank</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Student</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Score</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Submission Time</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Evaluation Status</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Status</TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                  }}
                                >Remarks</TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {filteredData
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage,
                                )
                                .map((row, i) => (
                                  <TableRow key={i}>
                                    <TableCell
                                      sx={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        color: "#222121",
                                      }}
                                    >
                                      {row.Rank}
                                    </TableCell>
                                    <TableCell>{row.Student}</TableCell>

                                    <TableCell
                                      sx={{
                                        textAlign: "center",
                                      }}
                                    >{Number(row.Score).toFixed(0)}</TableCell>

                                    <TableCell>{row.Submission}</TableCell>
                                    <TableCell>{row.Eval}</TableCell>

                                    <TableCell>
                                      <Chip
                                        label={
                                          row.Status === "YS"
                                            ? "Yet to submit"
                                            : row.Status === "EV"
                                              ? "Evaluated"
                                              : row.Status === "RS"
                                                ? "Resubmit"
                                                : row.Status === "PE"
                                                  ? "Pending"
                                                  : ""
                                        }
                                        size="medium"
                                        sx={{
                                          backgroundColor: getStatusColor(
                                            row.Status === "YS"
                                              ? "Yet to submit"
                                              : row.Status === "EV"
                                                ? "Evaluated"
                                                : row.Status === "RS"
                                                  ? "Resubmit"
                                                  : row.Status === "PE"
                                                    ? "Pending"
                                                    : "",
                                          ).bg,
                                          color: getStatusColor(
                                            row.Status === "YS"
                                              ? "Yet to submit"
                                              : row.Status === "EV"
                                                ? "Evaluated"
                                                : row.Status === "RS"
                                                  ? "Resubmit"
                                                  : row.Status === "PE"
                                                    ? "Pending"
                                                    : "",
                                          ).color,
                                          fontWeight: 500,
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>{row.Remarks}</TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>

                          {/* Pagination */}
                          <TablePagination
                            component="div"
                            count={filteredData.length}
                            page={page}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) =>
                              setRowsPerPage(parseInt(e.target.value, 10))
                            }
                            rowsPerPageOptions={[5, 10]}
                          />
                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default EditHomework;
